import utils from '../../app/utils'

import './style.css'

export default class PropertiesFilters {
    static selector = '.properties-filters'

    constructor(block) {
        this.block = block

        this.block
            .querySelector('#region')
            .addEventListener('change', (e) => {
                let value = '';
                if (e.target.value !== 'All regions') {
                    value = e.target.value;
                }
                window.App
                    .navigateTo(
                        `${window.location.pathname}${utils.prepareParamsForUrl(value, 'region')}`,
                        '#content',
                        '#content',
                        false,
                        {
                            afterContentInit: () => {
                                this.registerClearBtn()
                            },
                        }
                    );

                this.filtersClearBtn.classList.add('is-visible');
            });

        this.block
            .querySelector('#land_use')
            .addEventListener('change', (e) => {
                window.App
                    .navigateTo(
                        `${window.location.pathname}${utils.prepareParamsForUrl(e.target.value, 'land_use')}`,
                        '#content',
                        '#content',
                        false,
                        {
                            afterContentInit: () => {
                                this.registerClearBtn()
                            },
                        }
                    );

                this.filtersClearBtn.classList.add('is-visible');
            });

        this.block
            .querySelector('#price')
            .addEventListener('change', (e) => {
                window.App
                    .navigateTo(
                        `${window.location.pathname}${utils.prepareParamsForUrl(e.target.value, 'price')}`,
                        '#content',
                        '#content',
                        false,
                        {
                            afterContentInit: () => {
                                this.registerClearBtn()
                            },
                        }
                    );

                this.filtersClearBtn.classList.add('is-visible');
            });

        this.rangeInputLeft = this.block.querySelector(".range-box__input-left");
        this.rangeInputRight = this.block.querySelector(".range-box__input-right");

        this.rangeInputLeft.addEventListener('change', this.setMinValue.bind(this));
        this.rangeInputRight.addEventListener("change", this.setMaxValue.bind(this));

        this.registerClearBtn();
    }

    setMinValue() {
        window.App
            .navigateTo(
                `${window.location.pathname}${utils.prepareParamsForUrl(parseFloat(this.rangeInputLeft.value).toFixed(2), 'range_min')}`,
                '#content',
                '#content',
                false,
                {
                    afterContentInit: () => {
                        this.registerClearBtn()
                    },
                }
            );

        this.filtersClearBtn.classList.add('is-visible');
    }

    setMaxValue() {
        window.App
            .navigateTo(
                `${window.location.pathname}${utils.prepareParamsForUrl(parseFloat(this.rangeInputRight.value).toFixed(2), 'range_max')}`,
                '#content',
                '#content',
                false,
                {
                    afterContentInit: () => {
                        this.registerClearBtn();

                    },
                }
            );

        this.filtersClearBtn.classList.add('is-visible');
    }

    registerClearBtn() {
        this.filtersClearBtn = this.block.querySelector('.properties-filters__clear-filters');
        this.filtersClearBtn.addEventListener('click', () => {
            window.App
                .navigateTo(window.location.pathname);
        });
    }
}
